import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.398 16.2a.8.8 0 0 0 1.6 0V13a.8.8 0 0 0-1.6 0zM12.198 17a.8.8 0 0 1-.8-.8V13a.8.8 0 0 1 1.6 0v3.2a.8.8 0 0 1-.8.8M15.398 16.2a.8.8 0 0 0 1.6 0V13a.8.8 0 1 0-1.6 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.5 3.375a.8.8 0 0 1 .124 1.125l-2.96 3.7h8.671l-2.96-3.7a.8.8 0 1 1 1.25-1l3.76 4.7h1.656a1.6 1.6 0 0 1 1.574 1.886l-1.53 8.415a2.8 2.8 0 0 1-2.754 2.299H6.669a2.8 2.8 0 0 1-2.755-2.3l-1.53-8.414A1.6 1.6 0 0 1 3.958 8.2h1.657l3.76-4.7a.8.8 0 0 1 1.124-.125m-5.012 14.84L3.958 9.8h16.083l-1.53 8.415a1.2 1.2 0 0 1-1.18.985H6.669a1.2 1.2 0 0 1-1.18-.985",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }